<template>
  <div>
    <v-skeleton-loader type="paragraph"></v-skeleton-loader>

    <v-skeleton-loader type="paragraph" class="my-6"></v-skeleton-loader>

    <v-skeleton-loader type="paragraph"></v-skeleton-loader>
  </div>
</template>
<script>
export default {
  name: 'TranslationLoading',
}
</script>
